import { useEffect, useState } from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { ensureIdentity } from './lib/api.js';
import { flushAllPending } from './lib/drafts.js';
import { readIdentity } from './lib/identity.js';
import { Comic } from './screens/Comic.js';
import { CreateRoom } from './screens/CreateRoom.js';
import { Draw } from './screens/Draw.js';
import { Gallery } from './screens/Gallery.js';
import { Home } from './screens/Home.js';
import { Room } from './screens/Room.js';
import { Settings } from './screens/Settings.js';
import { SharedComic } from './screens/SharedComic.js';
import { SharedRoom } from './screens/SharedRoom.js';

/** Share routes are public: no identity, no join, just the comic. */
const PUBLIC_PREFIXES = ['/c/', '/r/'];

export function App() {
  const [ready, setReady] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const isPublic = PUBLIC_PREFIXES.some((prefix) => window.location.pathname.startsWith(prefix));
    if (isPublic && !readIdentity()) {
      setReady(true);
      return;
    }

    // First visit: an identity is created silently, with no sign-up anything (§5).
    ensureIdentity()
      .then(() => {
        setReady(true);
        // Anything stranded by a crash or a closed tab goes out now (guardrail #7).
        void flushAllPending();
      })
      .catch(() => {
        setError('Could not reach Panels. Check your connection and reload.');
        setReady(true);
      });
  }, []);

  if (!ready) {
    return (
      <div className="boot">
        <div className="boot-mark">PANELS</div>
      </div>
    );
  }

  return (
    <Router>
      {error ? <div className="banner banner-error">{error}</div> : null}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/create" element={<CreateRoom />} />
        <Route path="/room/:roomId" element={<Room />} />
        <Route path="/room/:roomId/draw/:panelId" element={<Draw />} />
        <Route path="/comic/:sheetId" element={<Comic />} />
        <Route path="/comics" element={<Gallery />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/c/:shareToken" element={<SharedComic />} />
        <Route path="/r/:shareToken" element={<SharedRoom />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}
